module.exports = __webpack_public_path__ + "media/images/favicon-e70a43896221e5b812ec26dfc2307800.png";